import { handleErrors } from '.';

export const APIupdateAsset = async (assetId: string, data: any) => (
  window.axios.patch(`/api/assets/${assetId}`, data)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIdeleteAsset = async (assetId: string) => (
  window.axios.delete(`/api/assets/${assetId}`)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIfetchAssets = async (params: { shared: boolean }) => (
  window.axios.get('/api/assets', { params })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);
